import React from "react";

const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

function fmt(n) { return n != null ? `₹${Number(n).toLocaleString("en-IN")}` : "—"; }

const EX_STYLE = {
  MISSING_BANK:        "text-red-400 bg-red-500/10 border-red-500/20",
  NEGATIVE_NET_RISK:   "text-orange-400 bg-orange-500/10 border-orange-500/20",
  MISSING_PAN:         "text-yellow-400 bg-yellow-500/10 border-yellow-500/20",
  LOP_UNRESOLVED:      "text-fuchsia-400 bg-fuchsia-500/10 border-fuchsia-500/20",
  BANK_VERIFY_PENDING: "text-blue-400 bg-blue-500/10 border-blue-500/20",
};

export default function EmployeePayrollGrid({ rows, onOpen, onHoldToggle }) {
  return (
    <div className={card}>
      <div className="px-5 py-4 border-b border-white/5 flex items-center justify-between">
        <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium">Employees in Run</span>
        <span className="text-xs text-white/30">{rows?.length || 0} records</span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-white/5">
              {["Code","Name","Dept","Location","Earnings","Deductions","Net","Exceptions","Hold",""].map(h => (
                <th key={h} className="px-3 py-3 text-left text-xs text-[#00ff90]/40 uppercase tracking-wider font-medium whitespace-nowrap">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {!rows?.length ? (
              <tr><td colSpan={10} className="px-4 py-8 text-center text-white/20 italic text-sm">No employees in this run.</td></tr>
            ) : rows.map(r => (
              <tr key={r.id} className={`border-b border-white/5 hover:bg-white/3 transition-colors ${r.onHold ? "opacity-50" : ""}`}>
                <td className="px-3 py-3 text-white/30 text-xs font-mono">{r.empCode}</td>
                <td className="px-3 py-3">
                  <button onClick={() => onOpen?.(r)} className="text-left hover:text-[#00ff90] transition-colors">
                    <p className="text-sm text-white/80 font-medium">{r.name}</p>
                  </button>
                </td>
                <td className="px-3 py-3 text-white/40 text-xs">{r.dept}</td>
                <td className="px-3 py-3 text-white/40 text-xs">{r.location}</td>
                <td className="px-3 py-3 text-white/70 text-xs text-right">{fmt(r.earnings)}</td>
                <td className="px-3 py-3 text-red-400/60 text-xs text-right">{fmt(r.deductions)}</td>
                <td className="px-3 py-3 text-right">
                  <span className="text-sm font-bold text-[#00ff90]">{fmt(r.net)}</span>
                </td>
                <td className="px-3 py-3">
                  <div className="flex flex-wrap gap-1">
                    {(r.exceptions || []).length === 0 ? (
                      <span className="text-white/20 text-xs">—</span>
                    ) : r.exceptions.map((e, i) => (
                      <span key={i} className={`text-xs px-1.5 py-0.5 rounded-full border ${EX_STYLE[e] || "text-white/40 bg-white/5 border-white/10"}`}>
                        {e.replace(/_/g, " ")}
                      </span>
                    ))}
                  </div>
                </td>
                <td className="px-3 py-3">
                  <label className="flex items-center gap-1.5 cursor-pointer">
                    <input type="checkbox" checked={!!r.onHold}
                      onChange={e => onHoldToggle?.(r.id, e.target.checked)}
                      className="w-4 h-4 rounded accent-[#00ff90]" />
                    <span className="text-xs text-white/30">{r.onHold ? "Held" : ""}</span>
                  </label>
                </td>
                <td className="px-3 py-3">
                  <button onClick={() => onOpen?.(r)}
                    className="text-xs px-3 py-1.5 rounded-lg border border-[#00ff90]/20 bg-[#00ff90]/5 text-[#00ff90]/60 hover:bg-[#00ff90]/15 hover:text-[#00ff90] transition-colors">
                    Open
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}